import React from 'react';

export default function BackgroundOrbs() {
  return (
    <div className="hero-orbs">
      <div className="orb orb-1"></div>
      <div className="orb orb-2"></div>
      <div className="orb orb-3"></div>
    </div>
  );
}